export default __webpack_public_path__ + "static/media/hht2_eggstudio.71506e5e.png";